import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { MultiSelectChangeEvent } from "primeng/multiselect";
import * as FlatModels from "@medsurf/flat-models";

@Component({
    selector: 'medsurf-design-input-multi-select',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './multi-select.input.design.html',
    styleUrls: ['./multi-select.input.design.scss'],
    standalone: false
})
export class MultiSelectInputDesign {
  @Input() formField = true;
  @Input({ required: true }) name!: string;
  @Input() inputType = 'text';
  @Input() inputClass: FlatModels.TextDesignModels.TextDesignClass = FlatModels.TextDesignModels.TextDesignClass.DEFAULT;
  @Input() options: {value: string, name: string}[] = [];
  @Input() optionLabel = 'name';
  @Input() optionValue = 'value';
  @Input() optionDisabled: string | null = null;
  @Input() showToggleAll = true;
  @Input() maxSelectedLabels = 2;
  @Input() group = false;
  @Input() filter?: boolean;
  @Input() placeholder = "";
  @Input() label?: string;
  @Input() labelIcon?: FlatModels.ButtonDesignModels.ButtonDefaultIcons;
  @Input() inputGroup = false;
  @Input() disabled = false;
  @Input({ required: true }) model!: string[];
  @Output() valueChange = new EventEmitter<MultiSelectChangeEvent>();
  
  readonly FlatModels = FlatModels;
}
